module.exports = __webpack_public_path__ + "static/media/video3_cut.c54716d7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/media/video3_cut.mp4
// module id = 806
// module chunks = 0